"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _getSaleableProductIdsKeyedByType = _interopRequireDefault(require("../get-saleable-product-ids-keyed-by-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getSaleableProductIds = function getSaleableProductIds(date) {
  return (0, _fp.flatten)((0, _fp.values)((0, _getSaleableProductIdsKeyedByType["default"])(date)));
};
var _default = exports["default"] = getSaleableProductIds;
module.exports = exports.default;